import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import presenters from './pictures/MicrosoftPresenters.jpeg';
import presenters2 from './pictures/microsoftPresenters2.jpeg';

const Microsoft = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Microsoft: Imposter Syndrome & Confidence in Tech</h2>
                    <p className="site-post-meta">March 30, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you so much to everyone who joined us on Monday, March 30th, for our WiC x Microsoft Imposter Syndrome & Confidence in Tech event! We heard amazing advice about battling imposter syndrome and learned how to gain confidence in tech from our wonderful panelists, Sangeetha and Maddie! We heard their insightful thoughts regarding their lessons learned, mindset shifts, and strategies that have helped them grow in their careers. 💗✨
                    <br></br>
                    <br></br>
                    We hope everyone enjoyed this amazing opportunity, and a special thank you to Sangeetha and Maddie for their time!
                    <br></br>
                    <br></br>
                    </p>
                    <img src={presenters} alt="Our presenters speaking to WiC"/>
                    <img src={presenters2} alt="Our presenters speaking to WiC"/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Microsoft;
